import React, { useEffect, useState, useRef } from "react";
import Search from "../../../../Assets/Images/search.png";
import Filter from "../../../../Assets/Images/filter.svg";
import file from "../../../../Assets/Images/file.png";
import CloseIcon from "@mui/icons-material/Close";
import { useGlobalContext } from "../../../../Context/GlobalContext";
import { saveAs } from "file-saver";
import ClipLoader from "react-spinners/ClipLoader";
import PaginationTab from "../../../../components/PaginationTab";
import { Link } from "react-router-dom";
import SearchStaff from "../../../../components/SearchStaff";
import Cookies from "js-cookie";
import { HeaderSkeleton, PaginationSkeleton, TableSkeleton } from "../StaffTab";

const OverTime_Pay_Policy = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedId, setSelectedId] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const {
    baseUrl,
    openToast,
    staffs,
    fetchStaffs,
    fetchDepartments,
    isLoading,
    setSelectedStaff,
    loadingStaffs
  } = useGlobalContext();




  const toggleAccordion = () => {
    setIsOpen((isOpen) => !isOpen);
  };

  const [toggleDrop, setToggleDrop] = useState(false);

  const dropdownRef = useRef(null);
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const staffDropDown = useRef(null);

  const handleSelectAll = () => {
    const newSelectAll = !selectAll; // Determine the new value of selectAll
    setSelectAll(newSelectAll);

    if (newSelectAll) {
      // If selectAll is true, select all staff IDs
      const allStaffIds = staffs?.map((staff) => staff?.staffDetails?.id);
      setSelectedId(allStaffIds);
    } else {
      // If selectAll is false, clear the selection
      setSelectedId([]);
    }
  };

  function handledrop() {
    setToggleDrop(!toggleDrop);
  }
  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };


  useEffect(() => {
    if (staffs?.length == 0) {
      fetchStaffs();
      fetchDepartments();
    }
  }, []);



  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setDropdownOpen(false);
    }
    if (staffDropDown.current && !staffDropDown.current.contains(e.target)) {
      setToggleDrop(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);
  const [overtimePayPolicy, setOvertimePayPolicy] = useState([]);
  const [fileUpload, setFileUpload] = useState(false);
  const fileInputRef = useRef(null); // Create a ref for the file input
  const [file, setFile] = useState(null); // Store the uploaded file
  function csvToJson(csvString) {
    // Split the CSV into rows
    const rows = csvString?.split("\n");

    // Extract headers from the first row
    const headers = rows[0]?.split(",");

    // Map the remaining rows to JSON objects
    const json = rows?.slice(1)?.map((row) => {
      const values = row?.split(",");
      return headers.reduce((obj, header, index) => {
        obj[header] = values[index]?.trim(); // Map each header to its value
        return obj;
      }, {});
    });

    return json;
  }

  const handleFileUpload = (event) => {
    const uploadedFile = event.target.files[0];
    if (uploadedFile) {
      setFile(uploadedFile);
      const reader = new FileReader();

      reader.onload = function (e) {
        try {
          const csvString = e.target.result;
          const jsonData = csvToJson(csvString);

          console.log("Parsed JSON:", jsonData);
          setOvertimePayPolicy(
            jsonData?.map((item) => {
              const keys = Object?.keys(item)?.filter(
                (key) =>
                  key !== "Index" && key !== "Name" && key !== "Job Title"
              );


              const headers = [
                "extraHoursPay",
                "gracePeriodMins",
                "publicHolidayPay",
                "weekOffPay",
              ];
              const data = {};

              for (let i = 0; i < keys?.length; i++) {
                const key = keys[i];
                data[headers[i]] = item[key] === "N/A" ? 0 : Number(item[key]);
              }

              return data;
            })
          );
        } catch (error) {
          console.error("Error parsing CSV:", error);
        }
      };

      reader.readAsText(uploadedFile);
      setFileUpload(false);
    }
  };

  async function createBulkOvertimePayPolicy() {
    const data = overtimePayPolicy.map((item, index) => ({
      ...item,
      staffId: staffs[index]?.staffDetails?.id
    }));

    try {
      const result = await fetch(baseUrl + "policy/overtime/bulk", {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`
        },
        body: JSON.stringify(data),
      });
      const res = await result.json();
      if (result.status == 201) {
        fetchStaffs();
        openToast(res.message || "Update Details Successfully", "success");
        setIsOpen(false);
      } else {
        openToast(res.message || "Internal Server Error", "error");
      }
    } catch (error) {
      if (error.message === "Failed to fetch") {
        openToast(
          "Unable to connect to the server. Please check your network or try again later.",
          "error"
        );
      } else {
        openToast("An unexpected error occurred. Please try again.", "error");
      }
    }
  }
  const handleButtonClick = () => {
    // Programmatically trigger the file input click
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  console.log(overtimePayPolicy);
  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile) {
      setFile(droppedFile);
      setFileUpload(false);
    }
  };

  useEffect(() => {
    if (overtimePayPolicy?.length > 0) {
      createBulkOvertimePayPolicy();
    }
  }, [overtimePayPolicy]);

  const exportToCSV = () => {
    // Define the CSV headers
    const headers = [
      "Index",
      "Name",
      "Job Title",
      "Extra Hours Pay",
      "Grace Period (mins)",
      "Public Holidays Pay",
      "Week Off Pay",
    ];

    // Map over the data to create CSV rows
    const rows = staffs.map((item, index) => {
      const overLeavePolicy = item?.staffDetails?.OverLeavePolicy?.[0] || {};
      return [
        index + 1,
        item?.name || "N/A",
        item?.staffDetails?.job_title || "N/A",
        overLeavePolicy?.extraHoursPay ?? "N/A",
        overLeavePolicy?.gracePeriodMins ?? "N/A",
        overLeavePolicy?.publicHolidayPay ?? "N/A",
        overLeavePolicy?.weekOffPay ?? "N/A",
      ];
    });

    // Combine headers and rows for CSV format
    const csvData = [headers, ...rows].map((row) => row.join(",")).join("\n");

    // Create a Blob and download the file
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "OverTime Pay.csv"); // Adjusted file name to "OverLeavePolicy.csv"
  };

  if (loadingStaffs && !staffs) {
    return (
      <div className="mt-[20px] staff-tab">
        <HeaderSkeleton />
        <TableSkeleton />
        <PaginationSkeleton />
      </div>
    );
  }


  return (
    <div className="mt-[20px] Early-Leaving-Policy">
      <div className="flex xl:flex-row flex-col md:flex-col lg:flex-col justify-between gap-[15px] lg:gap-[0px]">
        <div className="flex justify-between lg:justify-start gap-[15px] w-full">
          <SearchStaff dropdownRef={dropdownRef} setDropdownOpen={setDropdownOpen} toggleDropdown={toggleDropdown} isDropdownOpen={isDropdownOpen} />
          <div>
            <div className="inline-block relative text-left">
              <div>
                <button
                  onClick={() => setIsOpen(true)}
                  type="button"
                  className="shadow-sm w-full text-white second-btn"
                  id="menu-button"
                  aria-expanded="true"
                  aria-haspopup="true"
                >
                  Update Overtime Pay Policy
                </button>

                {isOpen && (
                  <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50">
                    <div className="border-[#B1B1B1] bg-white p-[2px] border rounded-lg sm:w-[100%] md:w-[84%] lg:w-[65%] 2xl:w-[40%] xl:w-[46%]">
                      <div className="relative bg-[#F0F6FE] shadow">
                        <h1 className="bg-[#F0F6FE] p-3 rounded-b-none rounded-r-lg rounded-t-lg text-[14px] text-center">
                          Import Overtime Policy for all Staff
                        </h1>
                        <button onClick={() => setIsOpen(false)} className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold">
                          <CloseIcon className="text-white" />
                        </button>
                      </div>

                      <div className="space-y-2 mx-1 my-6">
                        <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
                          <h1 className="font-medium">
                            Step 1. Download Overtime Policy template
                          </h1>
                          <button
                            onClick={exportToCSV}
                            className="border-[#B1B1B1] border-2 px-2 py-1 border-dashed rounded-sm text-[#B1B1B1] text-[12px] whitespace-nowrap"
                          >
                            Download Template
                          </button>
                        </div>

                        <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
                          <h1 className="font-medium">
                            Step 2. Edit downloaded file and add Overtime
                            Policy details
                          </h1>
                        </div>

                        <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
                          <h1 className="font-medium">
                            Step 3. Upload your Edited file
                          </h1>
                          <button
                            onClick={() => setFileUpload(true)}
                            className="border-[#B1B1B1] border-2 px-2 py-1 border-dashed rounded-sm text-[#B1B1B1] text-[12px]"
                          >
                            Update Overtime policy
                          </button>
                        </div>

                        {fileUpload && (
                          <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50">
                            <div className="border-[#B1B1B1] bg-white border rounded-lg sm:w-[100%] md:w-[84%] lg:w-[65%] 2xl:w-[40%] xl:w-[55%]">
                              {/* Modal Header */}
                              <div className="flex justify-between items-center bg-[#F0F6FE] shadow px-4 h-[75px]">
                                <h1 className="font-medium text-[#0E2040] text-[25px]">
                                  Import Early Leaving Policy for all Staff
                                </h1>
                                <button onClick={() => setFileUpload(false)}>
                                  <CloseIcon />
                                </button>
                              </div>

                              {/* Drag and Drop Area */}
                              <div
                                onDragOver={handleDragOver}
                                onDrop={handleDrop}
                                className="flex flex-col justify-center items-center border-2 bg-[#FAFAFA] mx-[80px] my-8 border-dotted rounded-md w-[78%] h-[218px]"
                              >
                                <img
                                  src={file ? URL.createObjectURL(file) : ""}
                                  alt=""
                                  className="mb-4 max-w-[100px] max-h-[100px]"
                                />
                                <h1 className="font-medium text-[15px]">
                                  Click or drag file to this area to upload
                                </h1>
                                <h1 className="text-[13px]">
                                  Supported formats: xls, xlsx file formats are
                                  supported
                                </h1>
                              </div>

                              {/* Hidden File Input */}
                              <input
                                type="file"
                                accept=".xls,.xlsx"
                                className="hidden"
                                ref={fileInputRef} // Assign the ref
                                onChange={handleFileUpload}
                              />

                              {/* Upload Button */}
                              <div
                                aria-disabled={file}
                                className="flex justify-center border-2 bg-[#FAFAFA] mx-[80px] my-8 border-dotted rounded-md w-[78%] h-[50px] cursor-pointer"
                                onClick={handleButtonClick}
                              >
                                <button
                                  disabled={file}
                                  className="text-[#B1B1B1] text-[20px] hover:text-black"
                                // Trigger the file input click
                                >
                                  Upload File
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex border-1 shadow mt-4 p-0 border rounded-md w-[100%] h-[100%] overflow-scroll overflow-y-auto">
        <div className="w-full">
          <table className="w-full table-section">
            <thead className="border-1 border">
              <th><input type="checkbox" className="border-1 border rounded-md" checked={selectAll}
                onClick={() => handleSelectAll()} /></th>
              <th>Name</th>
              <th>Job Title</th>
              <th>Extra Hours Pay </th>
              <th>Grace Period (mins)</th>
              <th>Public Holidays Pay</th>
              <th>Week of Pay</th>
            </thead>
            <tbody>

              {
                loadingStaffs && !staffs &&
                <tr className="h-[100px]">
                  <td
                    colSpan="11"
                    className="py-4 font-semibold text-center text-gray-600 text-xl"
                  >
                    <ClipLoader color="#27004a" size={50} />
                  </td>
                </tr>
              }

              {
                !loadingStaffs && staffs && staffs?.map((item) => {
                  const overTime = item?.staffDetails?.OverLeavePolicy?.[0];
                  return (
                    <tr className="border">
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        <input
                          checked={selectedId.includes(item?.staffDetails?.id)}
                          onChange={(e) =>
                            setSelectedId((prevSelectedId) => {
                              if (prevSelectedId?.includes(item?.staffDetails?.id)) {
                                return prevSelectedId?.filter((id) => id !== item?.staffDetails?.id);
                              } else {
                                return [...prevSelectedId, item?.staffDetails?.id];
                              }
                            })}
                          type="checkbox"
                          className="border-1 border rounded-md"
                        />
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        <Link
                          onClick={() => setSelectedStaff(item)}
                          to={`/edit-penalty/${item?.staffDetails?.id}`}
                          className="font-medium text-[#8A25B0]"
                        >
                          {item?.name}
                        </Link></td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        {item?.staffDetails?.job_title}
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        {overTime?.extraHoursPay ?? "N/A"}
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        {overTime?.gracePeriodMins ?? "N/A"}
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        {overTime?.publicHolidayPay ?? "N/A"}
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        {overTime?.weekOffPay ?? "N/A"}
                      </td>
                    </tr>
                  );
                })
              }

              {
                !loadingStaffs && staffs && staffs?.length === 0 &&
                <tr>
                  <td
                    colSpan="11"
                    className="py-4 font-semibold text-center text-gray-600 text-xl"
                  >
                    No Client Found
                  </td>
                </tr>
              }


            </tbody>
          </table>
        </div>
      </div>
      <PaginationTab />

    </div>
  );
};

export default OverTime_Pay_Policy;
